<div class="trial-offer-dialog" [ngSwitch]="state">

  <ng-container *ngSwitchCase="'offer'">
    <span class="dialog-icon" aria-hidden="true">
      <mat-icon class="dialog-icon-fill">verified</mat-icon>
      <mat-icon fontSet="material-icons-outlined">verified</mat-icon>
    </span>
    <h2 class="dialog-title">{{ 'trialOffer.offer.title' | translate }}</h2>
    <p class="dialog-body">{{ 'trialOffer.offer.body' | translate }}</p>
    <p class="dialog-error" *ngIf="errorKey">{{ errorKey | translate }}</p>

    <footer class="dialog-actions">
      <button
        mat-stroked-button
        type="button"
        [disabled]="submitting"
        (click)="onDismiss()"
        [ampTrack]="'action-button'"
        [ampTrackDetail]="'trial-offer-later'"
      >
        {{ 'trialOffer.offer.secondary' | translate | uppercase }}
      </button>
      <button
        mat-raised-button
        color="accent"
        type="button"
        [disabled]="submitting"
        (click)="onActivate()"
        [ampTrack]="'action-button'"
        [ampTrackDetail]="'trial-offer-start'"
      >
        <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
        <span [class.invisible]="submitting">{{ 'trialOffer.offer.primary' | translate | uppercase }}</span>
      </button>
    </footer>
  </ng-container>

  <ng-container *ngSwitchCase="'active'">
    <h2 class="dialog-title">{{ 'trialOffer.active.title' | translate }}</h2>
    <p class="dialog-body">
      {{ 'trialOffer.active.body' | translate: { date: (trialExpiry | date: 'mediumDate') } }}
    </p>

    <footer class="dialog-actions">
      <button mat-raised-button color="primary" type="button" (click)="onClose()">
        {{ 'trialOffer.active.primary' | translate | uppercase }}
      </button>
    </footer>
  </ng-container>

  <ng-container *ngSwitchCase="'availed'">
    <h2 class="dialog-title">{{ 'trialOffer.availed.title' | translate }}</h2>
    <p class="dialog-body">{{ 'trialOffer.availed.body' | translate }}</p>

    <footer class="dialog-actions">
      <button mat-stroked-button type="button" (click)="onClose()">
        {{ 'trialOffer.availed.secondary' | translate | uppercase }}
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onViewPlans()"
        [ampTrack]="'action-button'"
        [ampTrackDetail]="'trial-offer-view-plans'"
      >
        {{ 'trialOffer.availed.primary' | translate | uppercase }}
      </button>
    </footer>
  </ng-container>

  <ng-container *ngSwitchCase="'no-billing-access'">
    <h2 class="dialog-title">{{ 'trialOffer.noAccess.title' | translate }}</h2>
    <p class="dialog-body">{{ 'trialOffer.noAccess.body' | translate }}</p>

    <footer class="dialog-actions">
      <button mat-raised-button color="primary" type="button" (click)="onClose()">
        {{ 'trialOffer.noAccess.primary' | translate | uppercase }}
      </button>
    </footer>
  </ng-container>

</div>
